<template>
    <div
        key="small-boxes flex"
        class="small-box-container"
    >
        <plan-box />
        <card-box />
    </div>
</template>

<script>
import PlanBox from '@/components/Dashboard/Settings/Billing/PlanBox';
import CardBox from '@/components/Dashboard/Settings/Billing/CardBox';

export default {
    components: {
        PlanBox,
        CardBox,
    },
};
</script>
